import { forwardRef } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Zoom } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  closeButton: {
    position: 'absolute',
    right: 1,
    top: 1,
    color: 'white',
  },
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} />;
});

const PictureModal = ({ item, closeModal }) => {
  const classes = useStyles();

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      TransitionComponent={Transition}
      onClose={closeModal}
      // keepMounted
    >
      <DialogTitle>
        <Typography variant="h4">{item.name}</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={closeModal}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ height: '400px', backgroundImage: `url(${item.img})`, backgroundPosition: item.position || 'center', backgroundSize: 'cover' }} />
    </Dialog>
  );
};

export default PictureModal;
